const n = {
  "cdr-label-standalone": "cdr-label-standalone_15-0-1",
  "cdr-label-standalone__label-wrapper": "cdr-label-standalone__label-wrapper_15-0-1",
  "cdr-label-standalone__label": "cdr-label-standalone__label_15-0-1",
  "cdr-label-standalone__label--sr-only": "cdr-label-standalone__label--sr-only_15-0-1",
  "cdr-label-standalone__label--disabled": "cdr-label-standalone__label--disabled_15-0-1",
  "cdr-label-standalone__optional": "cdr-label-standalone__optional_15-0-1",
  "cdr-label-standalone__helper": "cdr-label-standalone__helper_15-0-1",
  "cdr-label-standalone__info": "cdr-label-standalone__info_15-0-1",
  "cdr-label-standalone__post-content": "cdr-label-standalone__post-content_15-0-1",
  "cdr-label-standalone__info-action": "cdr-label-standalone__info-action_15-0-1",
  "cdr-label-standalone__input-wrap": "cdr-label-standalone__input-wrap_15-0-1",
  "cdr-label-standalone__input-spacing": "cdr-label-standalone__input-spacing_15-0-1",
  "cdr-form-error": "cdr-form-error_15-0-1",
  "cdr-form-error__icon": "cdr-form-error__icon_15-0-1",
  "cdr-input": "cdr-input_15-0-1",
  "cdr-input--focus": "cdr-input--focus_15-0-1",
  "cdr-input--multiline": "cdr-input--multiline_15-0-1",
  "cdr-input--preicon": "cdr-input--preicon_15-0-1",
  "cdr-input--posticon": "cdr-input--posticon_15-0-1",
  "cdr-input--posticons": "cdr-input--posticons_15-0-1",
  "cdr-input--primary": "cdr-input--primary_15-0-1",
  "cdr-input--secondary": "cdr-input--secondary_15-0-1",
  "cdr-input--error": "cdr-input--error_15-0-1",
  "cdr-input--large": "cdr-input--large_15-0-1",
  "cdr-input--large@xs": "cdr-input--large@xs_15-0-1",
  "cdr-input--large@sm": "cdr-input--large@sm_15-0-1",
  "cdr-input--large@md": "cdr-input--large@md_15-0-1",
  "cdr-input--large@lg": "cdr-input--large@lg_15-0-1",
  "cdr-input__pre-icon": "cdr-input__pre-icon_15-0-1",
  "cdr-input__post-icon": "cdr-input__post-icon_15-0-1",
  "cdr-input__helper-text": "cdr-input__helper-text_15-0-1",
  "cdr-input-wrap": "cdr-input-wrap_15-0-1"
};
export {
  n as default
};
